import { NgIf } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, ViewChild } from '@angular/core';

@Component({
  standalone: true,
  imports: [NgIf],
  selector: 'app-mortgagee-custom-tooltip',
  templateUrl: './mortgagee-custom-tooltip.component.html',
  styleUrls: ['./mortgagee-custom-tooltip.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MortgageeCustomToolTipComponent {
  show = false;

  @ViewChild('tooltip', { static: false })
  tooltipEl!: ElementRef;

  onShow() {
    this.show = true;

    setTimeout(() => {
      this.adjustTooltipPosition();
    }, 0);
  }

  onHide() {
    this.show = false;
  }

  adjustTooltipPosition() {
    if (!this.tooltipEl) return;

    const tooltip: HTMLElement = this.tooltipEl.nativeElement;
    const rect = tooltip.getBoundingClientRect();

    tooltip.style.left = '0';
    tooltip.style.right = 'auto';
    tooltip.style.transform = 'none';
    if (rect.right > window.innerWidth - 8) {
      tooltip.style.left = 'auto';
      tooltip.style.right = '0';
    }
  }
}